var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUyu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.13607H23.5866C23.2857 8.01979 22.8284 6.96787 22.2387 6.00562H12V9.13607Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53058 21.6595H19.4702C20.5654 20.7873 21.5046 19.7278 22.2391 18.5291H1.76172C2.4963 19.7277 3.43548 20.7873 4.53058 21.6595Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.267334C12 1.31082 12 2.87602 12 2.87602H19.4699C17.42 1.24346 14.8242 0.267334 12 0.267334Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.13607H23.5866C23.2857 8.01979 22.8284 6.96787 22.2387 6.00562H12V9.13607Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2675C0 13.3506 0.144375 14.3998 0.413391 15.3979H23.5867C23.8556 14.3998 24 13.3506 24 12.2675H0Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.435 7.29246L8.96941 7.98185L9.74983 9.40122L8.15842 9.09682L7.95677 10.7044L6.84836 9.52202L5.73986 10.7044L5.53825 9.09682L3.94684 9.40113L4.72722 7.9818L3.26172 7.29246L4.72727 6.60316L3.94684 5.18379L5.5382 5.48819L5.73991 3.88062L6.84836 5.06299L7.95681 3.88062L8.15842 5.48819L9.74988 5.18379L8.96945 6.60321L10.435 7.29246Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUyu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UYU.8b72a0a2a5f92b49304fda1d47265798.svg";